import * as React from 'react'
import { InputNumber } from 'antd'
import { InputNumberProps } from 'antd/lib/input-number'

export const TTInputCurrency = React.forwardRef<HTMLInputElement, InputNumberProps>((props, ref) => {
    return (
        <InputNumber 
            defaultValue={0}
            step={0.01}
            decimalSeparator=","
            formatter={value => `${value}€`}
            parser={value => value.replace('€', '')}
            {...props}
            ref={ref}
        />
    )
})